export const randomNumberGenerator = () =>
    Math.floor(Math.random() * (999999999999999 - 100000000000000 + 1)) +
    100000000000000

let modelId = Date.now()

var defaultAppModeStorage = {
    chooseDevice: {
        cam: false,
        mic: false,
        pc: false,
    },
    trainModeSelect: {
        cam: false,
        mic: false,
    },
    trainMachine: {
        // isEnableNextBtn: false,
        // currentModelName: 'Model 1',
        currentModelId: modelId,
        // ImageClasses: {
        //     Class_1: {
        //         id: randomNumberGenerator(),
        //         className: 'Class 1',
        //         sampleType: 'Image',
        //         indexedDbId: 'Class 1',
        //         capturedImages: [],
        //     },
        // },
        // AudioClasses: {
        //     Class1: {
        //         id: randomNumberGenerator(),
        //         className: 'Class 1',
        //         sampleType: 'Audio',
        //         indexedDbId: 'Class 1',
        //         capturedAudio: [],
        //     },
        // },
        camModels: [
            {
                modelId: modelId,
                modelName: 'Model 1',
                epochs: 50,
                batchSize: 16,
                ImageClasses: {
                    Class_1: {
                        id: Date.now(),
                        className: 'Class 1',
                        sampleType: 'Image',
                        indexedDbId: 'Class 1',
                        capturedImages: [],
                        bgColor:
                            '#' +
                            Math.floor(Math.random() * 16777215).toString(16),
                    },
                },
                isGenerateTensor: false,
            },
        ],
        advanceSetting: {
            epochs: 50,
            batchSize: 16,
        },
    },
}

if (sessionStorage.getItem('appModeStorage') != null) {
    try {
        var appModeStorage = sessionStorage.getItem('appModeStorage')
        appModeStorage = JSON.parse(appModeStorage)
    } catch (e) {
        console.error(e)
        var appModeStorage = structuredClone(defaultAppModeStorage)
    }
} else {
    var appModeStorage = structuredClone(defaultAppModeStorage)
}

const appModeStorage_Reducer = (state = appModeStorage, action) => {
    switch (action.type) {
        case 'CHOOSE_DEVICE': {
            var data = { ...state, chooseDevice: action.payload }
            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }
        case 'TRAIN_MODE_SELECT': {
            var data = { ...state, trainModeSelect: action.payload }
            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'SET_TRAIN_MACHINE_STORE': {
            var data = { ...state }
            data.trainMachine = action.payload

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'ADD_CLASSES': {
            try {
                var data = { ...state }
                if (action.payload.classType == 'ImageClasses') {
                    // let ImageClasses = { ...data.trainMachine.ImageClasses }
                    let currentModel = data.trainMachine.camModels.find(
                        (model) =>
                            model.modelId === data.trainMachine.currentModelId
                    )
                    let ImageClasses = { ...currentModel.ImageClasses }
                    ImageClasses[action.payload.key] = action.payload.data
                    currentModel.ImageClasses = ImageClasses
                    // data.trainMachine.isEnableNextBtn = false
                    currentModel.isGenerateTensor = false
                }
                // else {
                //     let AudioClasses = { ...data.trainMachine.AudioClasses }
                //     AudioClasses[action.payload.data.className] =
                //         action.payload.data
                //     data.trainMachine.AudioClasses = AudioClasses
                // }

                sessionStorage.setItem('appModeStorage', JSON.stringify(data))
                return data
            } catch (e) {
                console.log('ERROR', e)
            }
        }
        case 'CHANGE_CLASSES': {
            var data = { ...state }
            if (action.payload.classType == 'ImageClasses') {
                // data.trainMachine.ImageClasses = { ...action.payload.data }
                // data.trainMachine.isEnableNextBtn = false

                let currentModel = data.trainMachine.camModels.find(
                    (model) =>
                        model.modelId === data.trainMachine.currentModelId
                )
                let ImageClasses = { ...currentModel.ImageClasses }
                ImageClasses = action.payload.data
                currentModel.ImageClasses = ImageClasses
            }
            // else {
            //     data.trainMachine.AudioClasses = { ...action.payload.data }
            // }

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }
        case 'ADVANCE_SETTING': {
            var data = { ...state }
            let currentModel = data.trainMachine.camModels.find(
                (model) => model.modelId === data.trainMachine.currentModelId
            )

            currentModel.epochs = action.payload.epochs
            currentModel.batchSize = action.payload.batchSize
            // data.trainMachine.advanceSetting = { ...action.payload }
            // data.trainMachine.isEnableNextBtn = false

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'TOGGLE_NEXT_BTN': {
            var data = { ...state }
            // data.trainMachine.isEnableNextBtn = action.payload
            let currentModel = data.trainMachine.camModels.find(
                (model) => model.modelId === data.trainMachine.currentModelId
            )
            currentModel.isGenerateTensor = action.payload

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'SET_DEFAULT_APPMODESTORAGE': {
            var data = structuredClone(defaultAppModeStorage)

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'SET_CURRENT_MODEL_ID': {
            var data = { ...state }
            data.trainMachine.currentModelId = action.payload

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }

        case 'SET_MODEL_DETAILS': {
            var data = { ...state }
            data.trainMachine.camModels = action.payload

            sessionStorage.setItem('appModeStorage', JSON.stringify(data))
            return data
        }
        default:
            sessionStorage.setItem('appModeStorage', JSON.stringify(state))
            return state
    }
}

export default appModeStorage_Reducer
